<template>
  <div>
    <!-- メイン -->
    <v-main>
      <v-container>

        <v-card flat max-height="10vh" class="mb-6">
          <v-row>
            <v-col cols="12" class="d-flex align-center justify-center text-h4">
              <span class="vf-font-title" style="font-weight: bold;">本人確認のご案内</span>
            </v-col>
          </v-row>
        </v-card>

        <v-card :loading="loading"  max-height="32vh" rounded="xl" color="green lighten-1" class="mx-0 mx-sm-16 mx-xl-16">
          <v-row>
            <!-- <v-col cols="4" class="d-flex align-center justify-end">
              <v-img src="@/assets/img/img-tqs.png" :max-width="imageTqsWidth"
              ></v-img>
            </v-col> -->
            <v-col cols="12" class="d-flex align-center justify-center text-h6 text-sm-h6 text-md-h5 text-lg-h5 text-xl-h4 mt-2">
              <span class="vf-font-logo">{{ $t("LCMV000") }}</span>
            </v-col>
          </v-row>
          <v-row class="text-body-1 text-sm-h5 text-xl-h5 mt-0">
            <v-col cols="1"></v-col>
            <v-col cols="5" class="d-flex align-center justify-center pr-0">
              氏名：
            </v-col>
            <v-col cols="5" class="d-flex align-center justify-start pl-0">
              {{ appName }} 様
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
          <v-row v-show="false" align="center" justify="center" class="text-body-1 text-sm-h5 text-xl-h5 mt-0" >
            <v-col cols="1"></v-col>
            <v-col cols="5" class="d-flex align-center justify-center  pr-0">
              性別：
            </v-col>
            <v-col cols="5" class="d-flex align-center justify-start  pl-0">
              {{ appSex }}
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
          <v-row v-show="false" align="center" justify="center" class="text-body-1 text-sm-h5 text-xl-h5 mt-0">
            <v-col cols="1"></v-col>
            <v-col cols="5" class="d-flex align-center justify-center">
              生年月日：
            </v-col>
            <v-col cols="5" class="d-flex align-center justify-start pl-0">
              {{ appBirthday }}
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </v-card>

        <v-card max-height="19vh" flat class="mt-6">
          <v-row>
            <v-col cols="1"></v-col>
            <v-col cols="10" class="d-flex align-center justify-center text-h6 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4">
              <span>上記内容が正しいことを確認し、本人確認ボタンを押してください。</span>
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </v-card>

        <v-card max-width="100vh" max-height="38vh" flat>
          <v-row>
            <!-- <v-col cols="1"></v-col> -->
            <v-col cols="2" class="d-flex align-center justify-end pl-0 pr-0 pb-0">
              <v-img src="@/assets/img/menkyo_gold.png" :max-width="imageStepWidth"></v-img>
            </v-col>
            <v-col cols="9" class="text-body-2 text-sm-h6 text-xl-h6 pl-0">
              <v-banner>
                ステップ１<br />
                <span>申請用書類の種類を選択します。</span>
              </v-banner>
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
          <v-row>
            <v-col cols="2" class="d-flex align-center justify-end pr-0 pr-0 pb-0">
              <v-img src="@/assets/img/smartphone_photo_man_yoko.png" :max-width="imageStepWidth"></v-img>
            </v-col>
            <v-col cols="9" class="text-body-2 text-sm-h6 text-xl-h6  pl-0">
              <v-banner>
                ステップ２<br />
                <span>申請用書類の撮影します。</span>
              </v-banner>
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
          <v-row>
            <v-col cols="2" class="d-flex align-center justify-end pr-0 pr-0 pb-0">
              <v-img src="@/assets/img/smartphone_photo_satsuei_man.png" :max-width="imageStepWidth"></v-img>
            </v-col>
            <v-col cols="9" class="text-body-2 text-sm-h6 text-xl-h6  pl-0">
              <v-banner>
                ステップ３<br />
                <span>顔の撮影します。</span>
              </v-banner>
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </v-card>

        <v-card max-height="18vh" flat class="mt-8">
          <v-row>
            <v-col cols="12" class="d-flex align-center justify-center">
              <v-btn x-large color="success" min-height="80px" :min-width="imageNextBtnWidth" dark @click="next()" :disabled="initializeErr" class="text-h5">本人確認</v-btn>
            </v-col>
          </v-row>
        </v-card>
        <comMessage :msg="dlgMsgErr.msg" :isOpen="dlgMsgErr.isOpen" :doYes="dlgMsgErr.doYes"/>
      </v-container>
    </v-main>
  </div>
</template>
<script>
import Constants from "../common/constantsVf";
import Utils from "../common/utils";
export default {
  name: "VFVerifyGuidance",
  data() {
    return {
      screenTitle: "本人確認案内",
      screenId: "APA100",
      loading: false,
      accesskey: "",
      receiptNo: "",
      systemId: "",
      appName: "",
      appSex: "",
      appBirthday: "",

      initializeErr: false,

      dlgMsgErr: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgErr.isOpen = false;
        },
      },
    };

    
  },
  computed: {
    imageTqsWidth() {
      let bp = this.$vuetify.breakpoint.name;
      if (bp == "xs" || bp == "sm" || bp == "md") {
        return "30%";
      } else if (bp == "lg") {
        return "20%";
      } else if (bp == "xl") {
        return "14%";
      } else {
        return "14%";
      }
    },
    imageStepWidth() {
      let bp = this.$vuetify.breakpoint.name;
      if (bp == "xs") {
        return "80%";
      } else if (bp == "sm" || bp == "md") {
        return "60%";
      } else if (bp == "lg" || bp == "xl") {
        return "40%";
      } else {
        return "38%";
      }
    },
    imageNextBtnWidth() {
      let bp = this.$vuetify.breakpoint.name;
      if (bp == "xs" || bp == "sm") {
        return "98%";
      } else if (bp == "md" || bp == "lg" || bp == "xl") {
        return "20%";
      } else {
        return "98%";
      }
    },
  },
  created(){
    this.initialize();
  },
  methods: {
    next: function() {
      this.$store.dispatch("vfAppInfo/setReceiptNo", this.receiptNo);
      this.$store.dispatch("vfAppInfo/setAccesskey", this.accesskey);
      this.$store.dispatch("vfAppInfo/setAppName", this.appName);
      this.$store.dispatch("vfAppInfo/setSystemId", this.systemId);
      this.$router.push(this.$router.resolve({ name: "APA200" }).href);
    },

     /*
    * 初期表示
    */
    initialize: function () {
      this.accesskey = this.$route.params['accesskey'];
      this.receiptNo = this.$route.params['receiptno'];
      this.systemId = this.$route.params['systemid'];
      this.$store.commit("vfAppInfo/resetState");
      this.getVerifyAppreqestInfo(this.accesskey,this.receiptNo,this.systemId);
    },
    
     /*
    * 申請者情報取得
    */
    getVerifyAppreqestInfo : async function(accesskey, receiptNo, systemId) {
      // サービス呼び出し
      let responseData = null;
      let apiurl = Constants.getUrlApiAPA100G01(accesskey);
      // 検索条件データ
      let data = JSON.stringify(this.searchVerifyAppreqestInfoData(receiptNo, systemId));
      try {
        let response = await this.$axios.post(apiurl, data,
            {
              headers: {"content-type": "application/json"}, 
              responseType: "json",
            });
         responseData = response.data;
         if (responseData.data != null) {
          // 会員情報表示
          this.displyVerifyAppreqestInfo(responseData);
          // 申請書類区分用データストア登録
          this.$store.dispatch("vfMaster/setAppDocKbnList", responseData.data.documentList);
          // 申請書類詳細区分用データストア登録
          this.$store.dispatch("vfMaster/setDocDetailKbnList", responseData.data.documentDetailList);
         }
         // 完了メッセージ表示
         this.showDialogMsgAfterAPICall(this.dlgMsgErr, responseData);
      } catch(error) {
        this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm110', ['申請者の表示']);
        this.dlgMsgErr.isOpen = true;
        this.initializeErr = true;
      } 
    },
     /*
    * 検索用リクエストデータ生成
    */  
    searchVerifyAppreqestInfoData: function(receiptNo, systemId){
      let reqData = {};
      reqData['receiptNo'] = receiptNo;
      reqData['systemId'] = systemId;
      return reqData;
    },

   /*
    * 申請者情報表示
    */
    displyVerifyAppreqestInfo: function(responseData){
      // if (responseData.data == null){
      //   return;
      // }
      let verifyAppreqestInfo = responseData.data;
      this.appName = verifyAppreqestInfo.name;
      this.appSex = verifyAppreqestInfo.sex;
      this.appBirthday = verifyAppreqestInfo.birthday;
    },

    /*
    * 完了メッセージ表示
    */
    showDialogMsgAfterAPICall : function(dialog, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null) {
        dialog.msg = this.$i18n.t('msg.err.cm110', ['申請者の表示']);
        dialog.isOpen = true;
        this.initializeErr = true;
        return hasError;
      }
      // API処理異常
      if (responseData.statusCd === 500) {
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          dialog.msg = Utils.createMsgViewStringForErrList(errorList);
          dialog.isOpen = true;
        } else {
          dialog.msg = responseData.message ;
          dialog.isOpen = true;
        }
        this.initializeErr = true;
        return hasError;
      }
    },
  },
};
</script>
<style scoped></style>
